"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsLettings = void 0;
const statsLettingsGetLettingsLocalAuthorityAverageListingPriceStatsLettingsLocalAuthorityAverageListingPriceLocalAuthorityCodeGet_js_1 = require("../funcs/statsLettingsGetLettingsLocalAuthorityAverageListingPriceStatsLettingsLocalAuthorityAverageListingPriceLocalAuthorityCodeGet.js");
const statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageAnnualYieldLocalAuthorityCodeGet_js_1 = require("../funcs/statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageAnnualYieldLocalAuthorityCodeGet.js");
const statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet_js_1 = require("../funcs/statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet.js");
const statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsNationalAverageAnnualYieldGet_js_1 = require("../funcs/statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsNationalAverageAnnualYieldGet.js");
const statsLettingsGetLettingsLocalAuthorityTotalPropertiesLetStatsLettingsLocalAuthorityTotalPropertiesLetLocalAuthorityCodeGet_js_1 = require("../funcs/statsLettingsGetLettingsLocalAuthorityTotalPropertiesLetStatsLettingsLocalAuthorityTotalPropertiesLetLocalAuthorityCodeGet.js");
const statsLettingsGetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGet_js_1 = require("../funcs/statsLettingsGetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGet.js");
const statsLettingsGetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGet_js_1 = require("../funcs/statsLettingsGetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGet.js");
const statsLettingsGetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGet_js_1 = require("../funcs/statsLettingsGetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class StatsLettings extends sdks_js_1.ClientSDK {
    /**
     * Local Authority - Get Average Listing Price
     *
     * @remarks
     * Calculate the average listing price (in £pcm) for rental properties in a local authority.
     *
     * - Average across all property types.
     * - Average by each property type.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLettingsLocalAuthorityAverageListingPriceStatsLettingsLocalAuthorityAverageListingPriceLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsLocalAuthorityAverageListingPriceStatsLettingsLocalAuthorityAverageListingPriceLocalAuthorityCodeGet_js_1.statsLettingsGetLettingsLocalAuthorityAverageListingPriceStatsLettingsLocalAuthorityAverageListingPriceLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * Local Authority - Get Average Annual Yield
     *
     * @remarks
     * Calculate the estimated annual rental yield for rental properties in a local authority
     *
     * - By each property type.
     * - Across all property types.
     * - This endpoint does not take time parameters - the average annual rental yield is updated nightly.
     */
    async getLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageAnnualYieldLocalAuthorityCodeGet(security, localAuthorityCode, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageAnnualYieldLocalAuthorityCodeGet_js_1.statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageAnnualYieldLocalAuthorityCodeGet)(this, security, localAuthorityCode, options));
    }
    /**
     * Local Authority - Get Average Time on Market
     *
     * @remarks
     * Calculate the average time a rental property was on the market (Available) for properties in a local authority.
     *
     * - Average by each property type.
     * - Average across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet_js_1.statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Get Average Annual Yield
     *
     * @remarks
     * Calculate the national average annual rental yield for rental properties.
     *
     * - Average by each property type.
     * - Average across all property types.
     * - This endpoint does not take time parameters - the average annual rental yield is updated nightly.
     */
    async getLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsNationalAverageAnnualYieldGet(security, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsNationalAverageAnnualYieldGet_js_1.statsLettingsGetLettingsLocalAuthorityAverageTimeOnMarketStatsLettingsNationalAverageAnnualYieldGet)(this, security, options));
    }
    /**
     * Local Authority - Get Total Properties Let
     *
     * @remarks
     * Calculate the total number of rental properties that were let (status with `Let Agreed`) in a local
     * authority.
     *
     * - Total by each property type.
     * - Total across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLettingsLocalAuthorityTotalPropertiesLetStatsLettingsLocalAuthorityTotalPropertiesLetLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsLocalAuthorityTotalPropertiesLetStatsLettingsLocalAuthorityTotalPropertiesLetLocalAuthorityCodeGet_js_1.statsLettingsGetLettingsLocalAuthorityTotalPropertiesLetStatsLettingsLocalAuthorityTotalPropertiesLetLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Get Average Listing Price
     *
     * @remarks
     * Calculate the national average price change (listing price in £ pcm) for a rental property for properties.
     *
     * - Average by each property type.
     * - Average across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGet_js_1.statsLettingsGetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGet)(this, security, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Get Total Properties Let
     *
     * @remarks
     * Calculate the national total number of rental properties that were let (status with `Let Agreed`).
     *
     * - Total by each property type.
     * - Total across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGet_js_1.statsLettingsGetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGet)(this, security, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Get Average Time on Market
     *
     * @remarks
     * Calculate the national average time a rental property was on the market for all properties.
     *
     * - Average by each property type.
     * - Average across all property types nationally.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsLettingsGetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGet_js_1.statsLettingsGetNationalAverageTimeOnMarketStatsLettingsNationalAverageTimeOnMarketGet)(this, security, filterEndDate, filterStartDate, options));
    }
}
exports.StatsLettings = StatsLettings;
//# sourceMappingURL=statslettings.js.map